import { render, staticRenderFns } from "./CowsRegistrationMainPage.vue?vue&type=template&id=86a1fa5e&scoped=true&"
import script from "./CowsRegistrationMainPage.vue?vue&type=script&lang=js&"
export * from "./CowsRegistrationMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a1fa5e",
  null
  
)

export default component.exports